"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentPhotoIdCreateFormAllOfPurposesEnum = exports.AttachmentPhotoIdCreateFormAllOfToJSON = exports.AttachmentPhotoIdCreateFormAllOfFromJSONTyped = exports.AttachmentPhotoIdCreateFormAllOfFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function AttachmentPhotoIdCreateFormAllOfFromJSON(json) {
    return AttachmentPhotoIdCreateFormAllOfFromJSONTyped(json, false);
}
exports.AttachmentPhotoIdCreateFormAllOfFromJSON = AttachmentPhotoIdCreateFormAllOfFromJSON;
function AttachmentPhotoIdCreateFormAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'acuantFields': (json['acuantFields'].map(_1.AcuantFieldFromJSON)),
        'acuantResponseJSON': json['acuantResponseJSON'],
        'ambassadorOverride': !runtime_1.exists(json, 'ambassadorOverride') ? undefined : json['ambassadorOverride'],
        'purposes': json['purposes'],
    };
}
exports.AttachmentPhotoIdCreateFormAllOfFromJSONTyped = AttachmentPhotoIdCreateFormAllOfFromJSONTyped;
function AttachmentPhotoIdCreateFormAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'acuantFields': (value.acuantFields.map(_1.AcuantFieldToJSON)),
        'acuantResponseJSON': value.acuantResponseJSON,
        'ambassadorOverride': value.ambassadorOverride,
        'purposes': value.purposes,
    };
}
exports.AttachmentPhotoIdCreateFormAllOfToJSON = AttachmentPhotoIdCreateFormAllOfToJSON;
/**
* @export
* @enum {string}
*/
var AttachmentPhotoIdCreateFormAllOfPurposesEnum;
(function (AttachmentPhotoIdCreateFormAllOfPurposesEnum) {
    AttachmentPhotoIdCreateFormAllOfPurposesEnum["FACIALIDENTIFICATION"] = "FACIAL_IDENTIFICATION";
    AttachmentPhotoIdCreateFormAllOfPurposesEnum["FINGERPRINTIDENTIFICATION"] = "FINGERPRINT_IDENTIFICATION";
    AttachmentPhotoIdCreateFormAllOfPurposesEnum["CITIZENSHIP"] = "CITIZENSHIP";
    AttachmentPhotoIdCreateFormAllOfPurposesEnum["NAMELINKING"] = "NAME_LINKING";
    AttachmentPhotoIdCreateFormAllOfPurposesEnum["PHOTOID"] = "PHOTO_ID";
})(AttachmentPhotoIdCreateFormAllOfPurposesEnum = exports.AttachmentPhotoIdCreateFormAllOfPurposesEnum || (exports.AttachmentPhotoIdCreateFormAllOfPurposesEnum = {}));
//# sourceMappingURL=AttachmentPhotoIdCreateFormAllOf.js.map